import { composeInitialState } from '@opengov/compose-app';
import { List } from 'immutable';

import { composeStateMachine } from './module';

export const initialState = composeInitialState({ queuedActionsToTrack: List() });

export const analyticsState = composeStateMachine('analytics', initialState, (compose) => ({
  clear: compose.payloadlessAction((state) => state.set('queuedActionsToTrack', initialState.queuedActionsToTrack)),
  track: compose.action((state, action: IAction<any, any>) =>
    state.set('queuedActionsToTrack', state.queuedActionsToTrack.push(action))
  )
}));

export const {
  actions: analyticsActions,
  actionCreators: analyticsActionCreators,
  reducer: analyticsReducer,
  selector: analyticsSelector
} = analyticsState;
